import { render, staticRenderFns } from "./DomainNameserverEdit.vue?vue&type=template&id=412a32f1"
import script from "./DomainNameserverEdit.vue?vue&type=script&lang=js"
export * from "./DomainNameserverEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports